"use client";

import { Container, Row } from "react-bootstrap";
import { ButtonPoll } from "../../atoms/ButtonPoll/ButtonPoll.tsx";

type Props = {
  data: PollData[];
};

type GroupedByLocalization = {
  [key: string]: PollData[];
};

export function HomeTemplate(props: Props) {
  // Funkcja do grupowania danych po lokalizacji
  const groupByLocalization = (data: PollData[]): GroupedByLocalization => {
    return data?.reduce((acc: GroupedByLocalization, item: PollData) => {
      if (acc[item.localization]) {
        acc[item.localization].push(item);
      } else {
        acc[item.localization] = [item];
      }
      return acc;
    }, {});
  };

  // Grupowanie danych przekazanych przez props
  const groupedData = groupByLocalization(props.data);

  if (!props?.data || props?.data?.length === 0) {
    return (
      <Container className="bg-white pt-3 pb-5">
        <h2>Obecnie nie ma nowych kursów</h2>
      </Container>
    );
  }

  return (
    <Container className="bg-white pt-3 pb-5">
      {Object.keys(groupedData).map((localization) => (
        <div className={"pb-4"} key={localization}>
          <h3 className={"text-danger "}>{localization}</h3>
          <Row className="g-3">
            {groupedData[localization]
              .sort((a, b) => a.order - b.order)
              .map((item: PollData) => (
              <ButtonPoll poll={item} key={item.id} />
              ))}
          </Row>
        </div>
      ))}
    </Container>
  );
}
